module.exports = __webpack_public_path__ + "2eab8d0f15e16ae391e9a3d43fa8105e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/048.jpg
// module id = 14
// module chunks = 0